// dashboardWidgetRegistryConfig/compactWidgetLayout.config.ts
export type CompactWidgetSize = "third" | "full";

export const COMPACT_WIDGET_SIZE: Record<number, CompactWidgetSize> = {
  202: "third", // Accounts
  66: "third", // Approvals
  216: "third", // Card Payment Due
  217: "third", // Cash Trend
  206: "third", // Repair Queue
  204: "third", // Quick Actions Grid
  64: "full", // Recent Repair Transactions
};

export const COMPACT_WIDGET_ROW: Record<number, number> = {
  202: 1,
  66: 1,
  216: 1,
  217: 2,
  206: 2,
  204: 2,
  64: 3,
};

// TEMPORARY - CardPaymentDueWidget (menuId 216) hidden per current requirement.
// Remove this entry (or clear the set) to re-enable it; no other code needs
// to change, the row will automatically reflow to 3 widgets again.
export const COMPACT_WIDGET_HIDDEN_MENU_IDS = new Set([
  216, // Card Payment Due (Temporary)
]);
